import { fetchMe } from "../store";
import { telegramAuth } from "./api";
import * as Sentry from "@sentry/browser";

const LOCAL_STORAGE_JWT_TOKEN_REF_NAME = "hg_access_token_4";

let authPromise: Promise<string> | null = null;
let authPlusProfilePromise: Promise<any> | null = null;

async function fetchAuthToken(): Promise<string> {
    const { body } = await telegramAuth();
    return body.jwt;
}

export function getAuthTokenPlusProfile(): Promise<any> {
    if (authPlusProfilePromise) return authPlusProfilePromise;

    authPlusProfilePromise = getAuthToken()
        .then(() => fetchMe())
        .finally(() => {
            authPlusProfilePromise = null;
        });

    return authPlusProfilePromise;
}

export function getAuthToken(): Promise<string> {
    let jwt = getJWTToken();
    // if we already have a token, return it immediately
    if (jwt && jwt != "null") return Promise.resolve(jwt);

    // if a request is already running, reuse its promise
    if (authPromise) return authPromise;

    // otherwise, start a new one
    authPromise = fetchAuthToken()
        .then(token => {
            setJWTToken(token);
            authPromise = null; // clear promise after done
            return token;
        })
        .catch(err => {
            authPromise = null;
            Sentry.captureException(err)
            throw err
        });

    return authPromise;
}

function setJWTToken(accessToken: string) {
    localStorage.setItem(LOCAL_STORAGE_JWT_TOKEN_REF_NAME, accessToken);
}

function getJWTToken(): string {
    return localStorage.getItem(LOCAL_STORAGE_JWT_TOKEN_REF_NAME) || 'null';
}